import styled from 'styled-components';
import type { Color } from '../../styles/variables';
import { SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';
import type { ThemeProps } from '../../types';

interface StyleProps {
  iconElevated?: boolean;
}

interface ThemeWithColorProps {
  theme: ThemeProps;
  bgColor?: Color;
  color?: string;
}

export const Container = styled.div<{ bgColor?: Color }>`
  width: 200px;
  background-color: ${(props: ThemeWithColorProps) =>
    props.bgColor || props.theme.sys.color.surface.neutral[800]};
  position: relative;
  @media ${device.tablet} {
    width: 250px;
  }
  @media ${device.laptop} {
    width: 300px;
  }
  p {
    text-align: center;
    color: ${(props: ThemeWithColorProps) => props.theme.sys.color.surface.neutral[100]};
  }
  #info-popover & {
    background-color: ${({ theme, bgColor }: ThemeWithColorProps) =>
      bgColor ?? theme.sys.color.surface.neutral[800]};
    ::before {
      border-bottom: 11.5px solid
        ${({ theme, bgColor }: ThemeWithColorProps) =>
          `${bgColor ?? theme.sys.color.surface.neutral[800]} !important`};
    }
  }
`;

export const IconWrap = styled.button`
  vertical-align: middle;
  background: transparent;
  margin-left: var(--spacing-relative-xs);
  margin-right: ${SIZING.unit(1.25)};
  padding: 0;
  height: 20px;
  width: 20px;
  border: none;
  cursor: pointer;
  margin-bottom: ${({ iconElevated }: StyleProps) => (iconElevated ? SIZING.unit(2.5) : 0)};
  &:focus {
    outline: 2px solid
      ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
    outline-offset: 2px;
    /* border-radius: 50%; */
  }
  :focus:not(:focus-visible) {
    outline: none;
    outline-offset: 0;
  }
`;

export const Copy = styled.p`
  font-family: 'Audi Type';
  font-size: var(--spacing-relative-sm);
  line-height: 15px;
  color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[500]};
  @media ${device.tablet} {
    font-size: 13px;
    line-height: 21px;
  }
`;

export const Title = styled(Copy)`
  @media ${device.tablet} {
    font-size: var(--spacing-relative-md);
    line-height: var(--spacing-relative-xl);
  }
`;

export const IconWrapper = styled.div<{
  color?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  svg {
    stroke: ${({ theme, color }: ThemeWithColorProps) =>
      color ?? theme.sys.color.surface.neutral[400]};
  }
`;
